import moment from "moment";
import Decorator from "@evertrue/client-decorator";
import React from "react";
import PropTypes from "prop-types";
import { useVolunteerSolicitorForContactAndPool } from "../contexts/volunteer-solicitor-resolver";
import { useCachedContactByIdResolver } from "../contexts/cached-contacts-context";
import { Icon, ContactCard } from "@evertrue/et-components";
import { useVolunteerSessionResolver } from "../contexts/volunteer-session-context";

const WIDTH = 300;

const VolunteerContactCard = ({
  pool,
  solicitor_contact_id,
  isVMSApp,
  isHeadAgentEnabled,
  orgFiscalYear,
  className,
  name_first,
  name_last,
  ...props
}) => {
  const { contact, loading } = useCachedContactByIdResolver(solicitor_contact_id);
  const formattedName = `${name_first} ${name_last}`;

  const solicitor = useVolunteerSolicitorForContactAndPool({
    contactId: solicitor_contact_id,
    poolId: pool.id,
  });
  const { session, loading: sessionLoading } = useVolunteerSessionResolver(solicitor_contact_id);

  const last_session_time = session.created_at ? moment(session.created_at).format("MM/DD/YYYY") : "-";

  const other_props = {
    ...(loading && { formattedName }),
    ...(isVMSApp && { showNameLink: false }),
  };
  // analytics API gives us first and last name only, so render that until contact resolves

  const has_given_last_fy = Decorator.Giving.getVolunteerHasGivenLastFY(pool, contact, orgFiscalYear);

  return (
    <ContactCard className={className} {...other_props} contact={contact}>
      {loading && "Loading..."}

      <div className="volunteers-stats-table--last-login">
        Last Login: {sessionLoading ? "Loading..." : last_session_time}
      </div>

      <div className="volunteer-stats-table--icon-container">
        {has_given_last_fy && <Icon size={1} className="volunteers-stats-table--given-tag" icon="given-tag" />}
        {isHeadAgentEnabled && solicitor.role === "Volunteer Lead" && (
          <Icon className="volunteers-stats-table--head-agent-icon" size={1} icon="head-agent" />
        )}
      </div>
    </ContactCard>
  );
};

VolunteerContactCard.propTypes = {
  className: PropTypes.string,
  isHeadAgentEnabled: PropTypes.bool,
  isVMSApp: PropTypes.bool,
  name_first: PropTypes.string,
  name_last: PropTypes.string,
  orgFiscalYear: PropTypes.string,
  pool: PropTypes.object,
  solicitor_contact_id: PropTypes.number,
};

export default VolunteerContactCard;
